
import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import Home from "../components/home.jsx";
import Footer from "../components/footer.jsx";

function HomePage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      < Home/> 
    </div>
    <Footer /> 
  </div>

  );
}
export default HomePage;
